import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Acluxurybusonrentinpune() {



  const cardData =
  {
    keyword: 'AC Luxury Bus On Rent in Pune',
    heading: 'Amruta Travels: AC Luxury Bus On Rent in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers AC Luxury Bus on Rent in Pune, delivering the ultimate travel experience for corporate groups, weddings, family tours, and outstation trips. Our fleet of high-end luxury coaches features plush push-back seats, powerful air conditioning, ambient lighting, and ample legroom, ensuring a premium and relaxing journey for every passenger. Each bus is maintained to the highest standards and driven by trained, uniformed chauffeurs who guarantee safety, punctuality, and professional service. Whether it’s a business event, a wedding function, or a weekend getaway to Mahabaleshwar, Shirdi, or Mumbai, Amruta Travels’ AC Luxury Bus Rental in Pune combines elegance, comfort, and reliability for a first-class group travel experience.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



    "services": [
    {
      "name": "AC Luxury Bus On Rent in Pune",
      "description": "AC Luxury Bus On Rent in Pune offers premium air-conditioned buses designed to provide a comfortable and stylish travel experience. These buses are perfect for corporate events, weddings, and leisure tours, equipped with plush seating, modern amenities, and driven by professional chauffeurs to ensure a smooth and luxurious journey."
    },
    {
      "name": "Luxury Bus Hire Pune",
      "description": "Luxury Bus Hire Pune specializes in providing high-end buses with elegant interiors and advanced comfort features. Ideal for VIP transportation, special events, and upscale tours, this service emphasizes punctuality, safety, and personalized attention to deliver an exceptional travel experience."
    },
    {
      "name": "AC Bus Rental Pune",
      "description": "AC Bus Rental Pune offers a wide range of air-conditioned buses suitable for all types of group travel. Whether for city commutes, corporate outings, or outstation trips, these buses combine reliability, cleanliness, and efficient service to meet diverse client needs."
    },
    {
      "name": "AC Coach Hire Pune",
      "description": "AC Coach Hire Pune provides spacious and comfortable air-conditioned coaches for large groups. Perfect for corporate events, school trips, and long-distance travel, these coaches ensure a relaxed journey with ample luggage space and courteous drivers experienced in navigating Pune’s routes."
    },
    {
      "name": "Volvo AC Bus Pune",
      "description": "Volvo AC Bus Pune offers luxurious Volvo buses equipped with state-of-the-art air conditioning, superior suspension systems, and plush seating. These buses are ideal for corporate travel, weddings, and premium outstation trips, combining safety and style for an unmatched travel experience."
    },
    {
      "name": "Mini Luxury Bus Pune",
      "description": "Mini Luxury Bus Pune provides compact yet premium buses perfect for smaller groups seeking comfort and style. These mini buses feature air conditioning, elegant interiors, and modern amenities, making them suitable for corporate transfers, VIP outings, and private tours within Pune."
    },
    {
      "name": "Luxury Tourist Bus Pune",
      "description": "Luxury Tourist Bus Pune caters to travelers looking for upscale transport options for sightseeing and leisure tours. These buses feature comfortable seating, large windows for panoramic views, and professional drivers knowledgeable about Pune’s tourist spots, ensuring an enjoyable and relaxed travel experience."
    },
    {
      "name": "Luxury Bus Hire in Baner",
      "description": "Luxury Bus Hire in Baner offers premium bus rental services tailored to the needs of Baner’s clientele. This service provides well-maintained, air-conditioned luxury buses with attentive drivers, ideal for weddings, corporate events, and group tours in and around the Baner area."
    },
    {
      "name": "Luxury Bus Hire in Hinjewadi",
      "description": "Luxury Bus Hire in Hinjewadi specializes in upscale bus rentals for corporate clients and professionals in the IT hub. These luxury buses are equipped with modern amenities and offer reliable, comfortable transport for business trips, client visits, and employee commutes."
    },
    {
      "name": "Luxury Bus Hire in Hadapsar",
      "description": "Luxury Bus Hire in Hadapsar provides high-end bus rental options for clients in Hadapsar seeking comfort and elegance. The fleet includes fully air-conditioned luxury buses with spacious seating and professional drivers, catering to weddings, corporate events, and leisure travel."
    },
    {
      "name": "Luxury Bus Hire in Pimpri",
      "description": "Luxury Bus Hire in Pimpri offers premium bus rentals tailored for the Pimpri area, ideal for corporate functions, weddings, and special occasions. These buses feature plush interiors, advanced air conditioning systems, and experienced chauffeurs focused on passenger comfort and safety."
    },
    {
      "name": "Corporate Luxury Bus Pune",
      "description": "Corporate Luxury Bus Pune delivers upscale bus rental services designed for business clients who require efficient and comfortable transport solutions. These luxury buses are ideal for employee commutes, corporate events, and client transportation, emphasizing professionalism and punctuality."
    },
    {
      "name": "Wedding Luxury Bus Pune",
      "description": "Wedding Luxury Bus Pune provides elegantly appointed buses that add a touch of sophistication to wedding transportation. These luxury buses feature stylish interiors, timely service, and attentive chauffeurs, ensuring that the wedding party travels in comfort and class."
    },
    {
      "name": "Outstation Luxury Bus Pune",
      "description": "Outstation Luxury Bus Pune specializes in long-distance luxury bus rentals for travel beyond Pune. Equipped with advanced amenities and spacious seating, these buses are perfect for corporate trips, leisure tours, and family outings, guaranteeing a comfortable journey over extended distances."
    },
    {
      "name": "Affordable Luxury Bus Pune",
      "description": "Affordable Luxury Bus Pune offers cost-effective options for renting luxury buses without compromising on quality or comfort. This service caters to budget-conscious clients who want premium features and reliable service at competitive prices."
    },
    {
      "name": "Luxury Bus Booking Online Pune",
      "description": "Luxury Bus Booking Online Pune provides a seamless digital platform for reserving luxury buses with ease. Customers can browse vehicle options, check availability, and complete bookings instantly, enjoying 24/7 support and multiple payment methods for convenience."
    },
    {
      "name": "Best AC Bus Pune",
      "description": "Best AC Bus Pune focuses on delivering top-quality air-conditioned buses that combine comfort, safety, and style. This service is popular among clients looking for the finest bus hire options for corporate travel, weddings, and group tours in Pune."
    },
    {
      "name": "Premium Bus Hire Pune",
      "description": "Premium Bus Hire Pune offers an exclusive range of luxury buses designed for discerning clients. With advanced features, elegant interiors, and highly professional drivers, this service guarantees an exceptional travel experience tailored to VIP and premium group needs."
    }
  ],
  "tableData": [
    ["AC Luxury Bus On Rent in Pune", "Luxury Bus Hire Pune"],
    ["AC Bus Rental Pune", "AC Coach Hire Pune"],
    ["Volvo AC Bus Pune", "Mini Luxury Bus Pune"],
    ["Luxury Tourist Bus Pune", "Luxury Bus Hire in Baner"],
    ["Luxury Bus Hire in Hinjewadi", "Luxury Bus Hire in Hadapsar"],
    ["Luxury Bus Hire in Pimpri", "Corporate Luxury Bus Pune"],
    ["Wedding Luxury Bus Pune", "Outstation Luxury Bus Pune"],
    ["Affordable Luxury Bus Pune", "Luxury Bus Booking Online Pune"],
    ["Best AC Bus Pune", "Premium Bus Hire Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "AC Luxury Bus On Rent in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers premium AC luxury bus rentals in Pune, perfect for comfortable and stylish group travel."
  },
  {
    "WhyChooseheading": "Spacious and Luxuriously Equipped Interiors",
    "WhyChoosedescription": "Our AC luxury buses feature plush seating, ample legroom, advanced climate control, and modern amenities for an upscale travel experience."
  },
  {
    "WhyChooseheading": "Regular Maintenance and Sanitization",
    "WhyChoosedescription": "We ensure all luxury buses are meticulously maintained and sanitized to provide a safe and hygienic environment."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Enjoy clear, upfront pricing with no hidden fees, offering great value for premium transportation."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental options tailored to your specific luxury travel needs."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs",
    "WhyChoosedescription": "Our skilled and courteous drivers ensure a safe, punctual, and pleasant journey every time."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our customer support team is available round-the-clock to assist with bookings, queries, and travel arrangements."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your AC luxury bus online or via phone with fast confirmation and reliable service across Pune."
  }
]




















  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer AC luxury bus rental services in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides AC luxury buses on rent in Pune, offering premium comfort and amenities for group travel.',
  },
  {
    question: 'How can I rent an AC luxury bus in Pune with Amruta Travels?',
    answer: 'You can easily rent an AC luxury bus through our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What features are available in the AC luxury buses for rent in Pune?',
    answer: 'Our AC luxury buses come equipped with comfortable seating, air conditioning, entertainment systems, and safety features for a superior travel experience.',
  },
  {
    question: 'Are the drivers experienced and professional for AC luxury bus rentals in Pune?',
    answer: 'Yes, all drivers are trained, courteous, and experienced in providing safe and smooth rides in AC luxury buses.',
  },
  {
    question: 'Can AC luxury buses be hired for weddings, corporate events, tours, and airport transfers in Pune?',
    answer: 'Absolutely. Our AC luxury buses are ideal for weddings, corporate outings, sightseeing tours, airport transfers, and other special occasions.',
  },
  {
    question: 'Is the AC luxury bus rental service available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for AC luxury bus rentals in Pune to suit your travel plans.',
  },
  {
    question: 'What safety and hygiene measures are followed for AC luxury bus rentals?',
    answer: 'All AC luxury buses are thoroughly sanitized before every trip, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment options are accepted for AC luxury bus rentals in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available during the AC luxury bus rental period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your AC luxury bus rental.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay Kulkarni',
    feedback: 'The AC luxury bus from Amruta Travels Pune provided a very comfortable and premium experience. The driver was professional and courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Deshmukh',
    feedback: 'Excellent AC luxury bus service for our corporate event. Highly recommend Amruta Travels for luxury bus rentals in Pune.',
    rating: 5,
  },
];






































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC Luxury Bus On Rent in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/20.jpg",
  "description": "Book AC Luxury Bus On Rent in Pune with Amruta Travels Pvt. Ltd. offering premium, air-conditioned luxury and Volvo buses for weddings, corporate trips, and outstation travel. Experience comfort and style with our luxury bus rental service in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.92",
    "ratingCount": "16890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/ac-luxury-bus-on-rent-in-pune"
  }
};





  return (
    <div>
<Helmet>
  <title>AC Luxury Bus On Rent in Pune | Volvo & Premium Bus Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book AC Luxury Bus On Rent in Pune with Amruta Travels Pvt. Ltd. offering premium, air-conditioned Volvo and luxury buses for weddings, corporate trips, and outstation travel. Reliable and affordable luxury bus rental in Pune."
  />
  <meta
    name="keywords"
    content="AC Luxury Bus On Rent in Pune, Luxury Bus Hire Pune, AC Bus Rental Pune, AC Coach Hire Pune, Volvo AC Bus Pune, Mini Luxury Bus Pune, Luxury Tourist Bus Pune, Luxury Bus Hire in Baner, Luxury Bus Hire in Hinjewadi, Luxury Bus Hire in Hadapsar, Luxury Bus Hire in Pimpri, Corporate Luxury Bus Pune, Wedding Luxury Bus Pune, Outstation Luxury Bus Pune, Affordable Luxury Bus Pune, Luxury Bus Booking Online Pune, Best AC Bus Pune, Premium Bus Hire Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Acluxurybusonrentinpune;